import { Component, Input } from '@angular/core';

import { WidgetStatePlaceholderEnum } from '@shared/enums/widget-state-placeholder.enum';

@Component({
  selector: 'app-widget-state-placeholder',
  templateUrl: './widget-state-placeholder.component.html'
})
export class WidgetStatePlaceholderComponent {
  @Input() stateType: WidgetStatePlaceholderEnum.DATA_NOT_AVAILABLE | WidgetStatePlaceholderEnum.DATA_NOT_FOUND;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
}
